import { checkIfEmptyValue } from "./checkIfEmptyValue";

export const deleteEmptyItems = (itemsArray: any[], lookupField) => {
  return itemsArray.filter((item) => {
    const isLookupFieldEmpty = checkIfEmptyValue(item[lookupField]);
    return !isLookupFieldEmpty || item.IS_BEING_MODIFIED_BY_AI;
  });
};
